module.exports = "<div style=\"position:relative;width:1080px;margin-left:auto;margin-right:auto;\">\n    <app-map></app-map>\n    <app-time-bar></app-time-bar>\n    <app-property-selector></app-property-selector>\n    <app-graph-dimoi-compared></app-graph-dimoi-compared>\n    <app-year-selector></app-year-selector>\n    <app-graph-pe1></app-graph-pe1>\n    <app-graph-pe2></app-graph-pe2>\n    <!-- <app-graph-manager></app-graph-manager> -->\n</div>\n\n<app-graph-popup></app-graph-popup>\n"


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main